import { render, staticRenderFns } from "./textEditing.vue?vue&type=template&id=17c52be9&"
import script from "./textEditing.vue?vue&type=script&lang=js&"
export * from "./textEditing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports